import { api } from '../lib/api'
import { setToken, setRefreshToken } from '../lib/auth'
import type { Me } from './me'

export type VerificationTicket = {
  verification_id: string
  email: string
  masked_email: string
  phone_provided: boolean
  expires_at: string
  resend_cooldown_seconds: number
  resend_available_at: string
  send_count: number
  dev_code?: string
}

export type RegisterPayload = {
  full_name: string
  email: string
  password: string
  phone?: string
  referral_code?: string
}

export async function register(payload: RegisterPayload): Promise<VerificationTicket> {
  const { data } = await api.post<VerificationTicket>('/api/auth/register/', payload)
  return data
}

export async function resendVerificationCode(verificationId: string): Promise<VerificationTicket> {
  const { data } = await api.post<VerificationTicket>('/api/auth/register/resend/', {
    verification_id: verificationId,
  })
  return data
}

export type VerifyCodeResponse = {
  access: string
  refresh: string
  user: Me
}

export async function verifyEmailCode(payload: { verification_id: string; code: string }) {
  const { data } = await api.post<VerifyCodeResponse>('/api/auth/register/verify/', payload)
  if (data?.access) setToken(data.access)
  if (data?.refresh) setRefreshToken(data.refresh)
  return data
}

export function extractAuthError(error: any): string {
  const detail =
    error?.response?.data?.detail ||
    error?.response?.data?.errors?.[0] ||
    error?.message ||
    'Something went wrong.'
  return typeof detail === 'string' ? detail : 'Something went wrong.'
}
